// Словарь виджета отзывов тестировщиков поверх всех экранов (ключи `feedback.*`). Подключается в `ru.ts`.

export const ruFeedback = {
  open: 'Сообщить об ошибке или идее',
  title: 'Отзыв о платформе',
  lead: 'Опишите, что не так или что улучшить. Можно выделить область экрана — снимок прикрепится',
  category: 'Что это',
  categories: {
    bug: 'Ошибка',
    idea: 'Идея',
    ux: 'Неудобно',
    other: 'Другое',
  },
  description: 'Описание',
  placeholder: 'Что произошло и что ожидали увидеть',
  capture: 'Выделить область',
  recapture: 'Выделить заново',
  removeShot: 'Убрать снимок',
  capturing: 'Делаем снимок…',
  selectHint: 'Выделите область мышью · Esc — отмена',
  shotAlt: 'Снимок выделенной области',
  shotFailed: 'Не удалось сделать снимок — отправьте отзыв без него или попробуйте ещё раз',
  send: 'Отправить',
  sending: 'Отправляем…',
  sent: 'Спасибо! Отзыв отправлен',
  failed: 'Не удалось отправить отзыв — попробуйте ещё раз',
  empty: 'Опишите проблему или идею',
  close: 'Закрыть',
};
